<template>
<span class="wrapper" :class="{'flex-end':$store.state.session.user.UserID === message.From}">
  <div class="" :class="{'messageBalloonMainReverse':$store.state.session.user.UserID === message.From,'messageBalloonMain':$store.state.session.user.UserID !== message.From}">
    <div
      class="spacer"
      v-if="$store.state.session.user.UserID === message.From"
    />
    <div
      :class="{
        speechBubbleTailedLeft:
          $store.state.session.user.UserID !== message.From &&
          !message.continueFromSameBuddy,
        speechBubbleNonTailedLeft:
          $store.state.session.user.UserID !== message.From &&
          message.continueFromSameBuddy,
        speechBubbleTailedRight:
          $store.state.session.user.UserID === message.From &&
          !message.continueFromSameBuddy,
        speechBubbleNonTailedRight:
          $store.state.session.user.UserID === message.From &&
          message.continueFromSameBuddy
      }"
    >
      <ForwardedMessageRow v-if="message.isForwarded" />
      <RepliedMessageRow v-if="message.ReplyMessage" :message="message.ReplyMessage" />

      <div
        class="senderName"
        :style="{ color: userColor(message.From) }"
        v-if="
          message.isGroup === true &&
            $store.state.session.user.UserID !== message.From &&
            !message.continueFromSameBuddy
        "
      >
        {{ getUserNameDisplay(message.From) }}
      </div>

      <MessageMenuDropDown :message="message" />

      <GmapMap
        :options="mapOptions"
        :center="coordinates"
        :zoom="16"
        style="width: 300px; height: 300px"
      >
        <GmapMarker :position="coordinates" />
      </GmapMap>

      <MessageBalloonInfoRow :message="message" />
    </div>
    <img class="forwardButton" src="/images/forward.png" v-if="$store.state.session.user.UserID !== message.From && message.MessageType !== 0" @click="forwardMsg">

    <div
      class="spacer"
      v-if="$store.state.session.user.UserID !== message.From"
    />
  </div>
</span>
</template>

<script>
import ForwardedMessageRow from './common/ForwardedMessageRow.vue'
import RepliedMessageRow from './common/RepliedMessageRow.vue'
import MessageBalloonInfoRow from './common/MessageBalloonInfoRow.vue'
import MessageMenuDropDown from './common/MessageMenuDropDown.vue'
import EventBus from '@/eventbus.js'
import {
  messageMixin
} from '@/mixins/messageMixin.js'

export default {
  components: {
    ForwardedMessageRow,
    RepliedMessageRow,
    MessageBalloonInfoRow,
    MessageMenuDropDown
  },

  mixins: [messageMixin],

  props: {
    message: {
      type: Object,
      default: function () {
        return {}
      }
    },
    index: {
      type: Number,
      default: 0
    }
  },

  data () {
    return {
      mapOptions: {
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        disableDefaultUi: false
      }
    }
  },

  computed: {
    coordinates () {
      return JSON.parse(this.message.Body)
    }
  },

  methods: {
    openGalleryView () {
      var vm = this
      this.$store.state.conversation.activeConversation.preview.imageGalleryView.isVisible = true
      setTimeout(function () {
        EventBus.$emit('imageGalleryViewOpenedWithMessage', vm.message)
      }, 50)
    },

    forwardMsg () {
      let messageToForward = this.message
      this.$store.commit('setMessageToForward', messageToForward)

      this.$store.state.display.modal.viewState = 'forwardMessage'
      this.$modal.show('homepage')
    }
  }
}

</script>

<style lang="less" scoped>
  @import "../../../../../style/messageBalloon";
</style>
